export default "__VITE_ASSET__S5_F5eOp__"